import React from "react";

const Interest = () => {
  return (
            <div>
            <h4  className="resume-heading">Interest</h4>
    <div id="interest" className="resume_screen_container">
      <div className="resume_heading">
        <div className="resume_main_heading">
          <div className="heading_bullet"></div>
          <span>Learning</span>
          <div></div>
        </div>
        <div className="resume_sub_heading">
          <span></span>
        </div>
        <div className="resume_heading_description">
          <span>
           Learning latest features of documentation which is related to my web development skill.I also enjoy to keep improving myself with continue study.         </span>
        </div>
      </div>
      <div className="resume_heading">
        <div className="resume_main_heading">
          <div className="heading_bullet"></div>
          <span>Teaching</span>
          <div></div>
        </div>
        <div className="resume_sub_heading">
          <span></span>
        </div>
        <div className="resume_heading_description">
          <span>Sometimes try to teach programming who is not to know programming , what is programming ?, How is it importance and how is it work?
           
          </span>
        </div>
      </div>
      <div className="resume_heading">
        <div className="resume_main_heading">
          <div className="heading_bullet"></div>
          <span>Music</span>
          <div></div>
        </div>
        <div className="resume_sub_heading">
          <span></span>
        </div>
        <div className="resume_heading_description">
          <span>
           I am music lover person.When I get free time try to hear music.But When I fall down in depression then I read QURAN or Listening recitation of QURAN.
          </span>
        </div>
      </div>
    </div>
    </div>
  );
};

export default Interest;
